module.exports = __webpack_public_path__ + "img/yf.30ea7058.jpg";